export const SESSION_COOKIE_KEY = "headway-session.token";
export const LOCAL_COOKIE_ACCEPT_KEY = "headway-session.accept-cookies";

export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const GTM_DEBUG = process.env.NEXT_PUBLIC_GTM_DEBUG;
